<template>
  <div class="banner-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @showDetail="showDetail">
      <ui-button :color="'green'"
                 @click="openCreate">
        <i class="xi-plus"></i> 배너 생성
      </ui-button>
    </template-search-list>

    <banner-editor-modal :show="modal.show"
                         :mode="modal.mode"
                         :bannerId="modal.bannerId"
                         @saved="handleSaved"
                         @close="closeModal" />
  </div>
</template>

<script>
import { getBannerList } from '@/api/marketing'

import TemplateSearchList from '@/components/_template/SearchList'
import BannerEditorModal from '@/components/marketing/banner/BannerEditorModal'
import UiButton from '@/components/_ui/UiButton'

export default {
  name: 'MarketingBannerList',
  components: {
    TemplateSearchList,
    BannerEditorModal,
    UiButton
  },
  methods: {
    openCreate () {
      this.modal = {
        show: true,
        mode: 'create',
        bannerId: null
      }
    },
    showDetail (data) {
      this.modal = {
        show: true,
        mode: 'detail',
        bannerId: data._id || data.id || data.groupId
      }
    },
    reloadList () {
      this.reload++
    },
    setSelected (row) {
      this.selected = row
    },
    handleSaved () {
      this.closeModal()
      this.reloadList()
    },
    closeModal () {
      this.selected = null
      this.modal = {
        show: false,
        mode: 'create',
        bannerId: null
      }
    }
  },
  data () {
    return {
      reload: 0,
      selected: null,

      listApi: getBannerList,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',
      modal: {
        show: false,
        mode: 'create',
        bannerId: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-list-wrap {
  ::v-deep .list-table {
    & > thead {
      tr {
        th {
          &.bannerName {
            width: 100px;
          }
        }
      }
    }
  }
}
</style>
